
import Vue from 'vue';
import { APP_ERROR_EVENT } from '../../../../constants';
import { Core } from '../../../../services/core';
import { FilterPartEntity, FilterPartsStore } from '../../../../services/parts';

export default Vue.extend({
  name: 'partsLightSourcesView',
  data() {
    return {
      isMounted: false,
      isLoading: false,

      metadata: {
        filter: undefined as FilterPartEntity | undefined,
      },
    };
  },

  beforeMount() {
    this.$metronic.breadcrumbs.setBreadcrumbs([
      { title: 'Parts', route: '/parts' },
      { title: 'Filter glasses', route: '/parts/filters' },
    ]);
  },

  async mounted() {
    this.$set(this, 'isLoading', true);
    try {
      const [filter] = await Promise.all([FilterPartsStore.get(this.$route.params.guid)]);

      this.$set(this.metadata, 'filter', filter);
    } catch (e) {
      console.error(e);
      Core.Eventhub.emit(APP_ERROR_EVENT, e);
      return;
    } finally {
      this.$set(this, 'isMounted', true);
      this.$set(this, 'isLoading', false);
    }

    this.$metronic.breadcrumbs.appendBreadcrumb({
      title: this.metadata.filter?.description as string,
    });
  },
});
